import { preload } from './modules/preload'
import { nav } from './modules/nav'
import { slider } from './modules/slider'
import { facts } from './modules/facts'
import { toggleItem } from './modules/toggleItem'
import { counter } from './modules/counter'
import { lightbox } from './modules/lightbox'
import { openFilter } from './modules/openFilter'
import { onScroll } from './modules/onScroll'
import { dialog } from './modules/dialog'
import { gsap } from './modules/gsap'

window.onload = function () {
	let sliders= slider()
	onScroll()
	preload()
	nav()
	openFilter()
	lightbox()
	counter()
	dialog()
	toggleItem()
	facts()
	gsap()

	window.activeSliders = sliders;

	// If BG Color is not White
	// if (window.getComputedStyle(document.body).getPropertyValue('--bg-pri') && window.getComputedStyle(document.body).getPropertyValue('--bg-pri') != '#fff') {
	// 	document.querySelector('meta[name="theme-color"]').setAttribute('content', window.getComputedStyle(document.body).getPropertyValue('--bg-pri'))
	// }
}
